import { MessageCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useChat } from "@/contexts/ChatContext";
import { useUnreadMessages } from "@/hooks/useUnreadMessages";

const ChatBubble = () => {
  const { profile, isSignedIn } = useAuth();
  const { activeConversationId, isOpen, openChat } = useChat();
  const unreadCount = useUnreadMessages(profile?.id);

  if (!isSignedIn || isOpen) return null;

  return (
    <button
      onClick={() => openChat(activeConversationId)}
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center rounded-full shadow-lg transition-transform hover:scale-110"
      style={{
        backgroundColor: "#3273a4",
        color: "#ffffff",
        width: "56px",
        height: "56px",
      }}
      title="Chat"
    >
      <MessageCircle size={26} />
      {unreadCount > 0 && (
        <span
          className="absolute -top-1 -right-1 rounded-full flex items-center justify-center text-[10px] text-white min-w-[20px] h-5 px-1"
          style={{ backgroundColor: "#c33c04", fontWeight: 700 }}
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>
  );
};

export default ChatBubble;
